module.exports = __webpack_public_path__ + "img/fd_noluck_btn.61b68c46.png";